import {BaseDTO} from '../../common/models/BaseDTO';

export class CaseStatusDTO extends BaseDTO {
  caseStatusId: bigint | number;
  statusName: string;
}
